export default __webpack_public_path__ + "static/front--23-8ceb8db7e896f6794aabf9332528dc4b.webp";